import { ChangeEvent, FC, MouseEventHandler } from 'react';
import classNames from 'classnames';

import { Typography } from '../Typography/Typography';

import './InputRange.css';

interface InputRangeProps {
	id?: string;
	error?: string;
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
	value: number | string;
	name?: string;
	disabled?: boolean;
	hideErrorMessage?: boolean;
	min: number;
	max: number;
	step?: number;
	dataType?: string;
	maxLabel?: string | number;
	minLabel?: string | number;

	onMouseUp?: MouseEventHandler<HTMLInputElement>;
}

export const InputRange: FC<InputRangeProps> = ({
	id,
	name,
	error,
	onChange,
	value,
	disabled,
	hideErrorMessage,
	onMouseUp,
	min,
	max,
	minLabel,
	maxLabel,
	step = 1,
	dataType,
}) => {
	const { Text } = Typography;
	const valueNumbers = typeof value === `string` ? Number(value.toString().match(/\b\d+\b/)) : value;

	return (
		<div className='styled-slyder__block'>
			<input
				className={classNames(
					`styled-slider`,
					`slider-progress`,
					error && `input__field--error`,
					disabled && `input__field--disabled`,
				)}
				type='range'
				id={id}
				value={valueNumbers}
				onChange={onChange}
				onMouseUp={onMouseUp}
				name={name}
				min={min}
				max={max}
				step={step}
				disabled={disabled}
				style={{ '--ratio': (valueNumbers - min) / (max - min) } as React.CSSProperties}
			/>
			<div className='styled-slyder__range'>
				<Text>
					{minLabel || min} {dataType}
				</Text>
				<Text>
					{maxLabel || max} {dataType}
				</Text>
			</div>

			{error && !hideErrorMessage && (
				<Text variant='note' className='input__error-text'>
					{error}
				</Text>
			)}
		</div>
	);
};
